module.exports = __webpack_public_path__ + "img/Homebg_dark.918356fa.jpg";